export const getDashboardUrl = async (dashboardId: number) => {
  const url = `https://zbxf5cwgme.execute-api.ap-southeast-2.amazonaws.com/dev/dashboardLink/${dashboardId}`;
  try {
    const response = await fetch(url, {
      method: "GET",
    });
    if (!response.ok) {
      return "";
    }
    return await response.text();
  } catch (ex) {
    return "";
  }
};
